var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.425 20.433H17.191L18.411 6.569H6.205L7.425 20.433ZM14.619 3.566H10.024L10.023 5.002H14.618L14.619 3.566ZM16.186 3.305L16.185 5.002L21.642 5.003V6.569H19.984L18.689 21.285C18.653 21.689 18.314 22 17.908 22H6.708C6.302 22 5.963 21.689 5.928 21.285L4.633 6.569H3V5.003L8.456 5.002L8.457 3.305C8.457 2.631 8.972 2.074 9.629 2.007L9.763 2H14.88C15.6 2 16.186 2.586 16.186 3.305ZM13.1049 18.1342H11.5379V8.86524H13.1049V18.1342ZM14.567 8.83684L16.133 8.89384L15.794 18.1618L14.228 18.1048L14.567 8.83684ZM10.0758 8.83594L10.4148 18.1049L8.84877 18.1619L8.50977 8.89394L10.0758 8.83594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBinWhite);
export default __webpack_public_path__ + "static/media/ic_bin_white.08624a5d844b14483c362490e26e8487.svg";
export { ForwardRef as ReactComponent };